import { Link } from "react-router-dom";

interface SectionHeadingProps {
  title: string;
  subtitle?: string;
  moreLink?: string;
  moreText?: string;
}

export default function SectionHeading({
  title,
  subtitle,
  moreLink,
  moreText = "查看全部",
}: SectionHeadingProps) {
  return (
    <div className="flex items-end justify-between mb-5 md:mb-6">
      <div className="flex items-center gap-3">
        <span className="w-1.5 h-6 md:h-7 rounded-full bg-accent-500" />
        <div>
          <h2 className="text-lg md:text-xl font-bold text-foreground-950 font-heading">
            {title}
          </h2>
          {subtitle && (
            <p className="text-xs md:text-sm text-foreground-500 mt-0.5">
              {subtitle}
            </p>
          )}
        </div>
      </div>
      {moreLink && (
        <Link
          to={moreLink}
          className="inline-flex items-center gap-1 text-xs md:text-sm text-foreground-500 hover:text-primary-600 transition-colors whitespace-nowrap"
        >
          {moreText}
          <i className="ri-arrow-right-s-line text-base" />
        </Link>
      )}
    </div>
  );
}